<!-- HARDIK KUMAR code start-->

<div class="row" id="CsRow">
  <div class="col-md-12" id="CsCol">
    <mat-card appearance="outlined" class="marB16" id="CsmatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="CsBtn">
          <mat-icon class="close-icon" color="warn" id="CsIcon">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="CsHeader">{{ checkStatusChangeObj.activityName }}</h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft" id="CsList">
            {{ loginUserName || 'NA' | initials }}
          </span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="CsH5">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span
              class="marginicon40 mainBodyTxt3 GreyLight blockInfo"
              *ngIf="timeModifiedOn; else elseTemplate"
              id="CsDate"
            >
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="CsTemp"> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content class="clearfix" *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readflag }">
        <form name="statuschangeForm" #f1="ngForm">
          <div *ngIf="this.testformValid(!f1.invalid)"></div>
          <div class="mutil-selector-wrap" *ngIf="checkStatusChangeObj !== undefined">
            <div class="marR16">
              <mat-form-field class="custom-form-field">
                <mat-label>Reason </mat-label>
                <mat-select [(ngModel)]="reasonId" name="coupledreasonId" required [value]="reasonId">
                  <mat-option *ngFor="let reason of rejectionReasons | keyvalue" [value]="reason.key">
                    {{ reason.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <mat-form-field class="custom-form-field" *ngIf="checkStatusChangeObj !== undefined">
            <input
              matInput
              placeholder="Remarks"
              name="couplednotes"
              [(ngModel)]="notes"
              (input)="selectedValue = $event.target.value"
            />
          </mat-form-field>

          <mat-card appearance="outlined" *ngIf="checkStatusChangeObj !== undefined">
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="col-md-2">
              <div class="row nomarLR padTB16">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="coupledsendbtn"
                  [disabled]="f1.invalid || disableSFO"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>

<!-- HARDIK KUMAR code ends -->
